// import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
// import { Container } from 'react-bootstrap';
// import { AuthProvider, useAuth } from './context/AuthContext';

// import Dashboard from './components/Dashboard';
// import AuthHandler from './components/AuthHandler';
// import Profile from './components/Profile';
// import SalesList from './components/SalesList';
// import CreditsList from './components/CreditsList';
// import CreditDetail from './components/CreditDetail';
// import ExpenseList from './components/ExpenseList';
// import ExpenseForm from './components/ExpenseForm';
// import NavigationBar from './components/NavigationBar';
// import HomePage from './components/HomePage';
// import { useLocation } from 'react-router-dom';
// import { initGA, trackPageView } from './utils/GoogleAnalytics';
// import 'bootstrap/dist/css/bootstrap.min.css';

// // Protected route component
// const ProtectedRoute = ({ children }) => {
//   const { user } = useAuth();
//   return user ? children : <Navigate to="/auth" replace />;
// };

// export default function App() {
//   const location = useLocation();

//   useEffect(() => {
//     // Initialize GA on first load
//     initGA();
    
//     // Track initial page view
//     trackPageView(window.location.pathname);
//   }, []);

//   useEffect(() => {
//     // Track page view on route change
//     trackPageView(location.pathname);
//   }, [location]);

//   return (
//     <BrowserRouter>
//       <AuthProvider>
//       <NavigationBar /> 
//         <Container className="mt-5">
//           <Routes>
//             <Route path="/" element={<HomePage />} /> {/* ✅ Public homepage */}
//             <Route path="/auth" element={<AuthHandler />} />

//             <Route path="/dashboard" element={
//               <ProtectedRoute>
//                 <Dashboard />
//               </ProtectedRoute>
//             } />

//             <Route path="/sales-list" element={
//               <ProtectedRoute>
//                 <SalesList />
//               </ProtectedRoute>
//             } />

//             <Route path="/credits" element={
//               <ProtectedRoute>
//                 <CreditsList />
//               </ProtectedRoute>
//             } />

//             <Route path="/credits/:id" element={
//               <ProtectedRoute>
//                 <CreditDetail />
//               </ProtectedRoute>
//             } />

//             <Route path="/expenses" element={
//               <ProtectedRoute>
//                 <ExpenseList />
//               </ProtectedRoute>
//             } />

//             <Route path="/add-expense" element={
//               <ProtectedRoute>
//                 <ExpenseForm />
//               </ProtectedRoute>
//             } />

//             <Route path="/edit-expense/:id" element={
//               <ProtectedRoute>
//                 <ExpenseForm isEdit={true} />
//               </ProtectedRoute>
//             } />

//             <Route path="/profile" element={
//               <ProtectedRoute>
//                 <Profile />
//               </ProtectedRoute>
//             } />

//             <Route path="*" element={<Navigate to="/" replace />} />
//           </Routes>
//         </Container>
//       </AuthProvider>
//     </BrowserRouter>
//   );
// }
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import AppRoutes from './AppRoutes';
import 'bootstrap/dist/css/bootstrap.min.css';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
